<div
  class="city-item--content"
  [ngStyle]="{'background-image': backgroundImage}"
>
  <div class="city-item--title"><h3>{{ data.location }}</h3></div>
</div>
